export default "__VITE_ASSET__8Yv09QnU__"